import type User from "@/Model/User";
import { container } from "tsyringe";

export interface IUserProvider {
    getUser(): User;
}

export default class UserProvider {
    public static getInstance(): IUserProvider {
        return container.resolve<IUserProvider>("UserProvider");
    }
}